import { render } from "./priceListsView.vue?vue&type=template&id=a2d9dcda&scoped=true"
import script from "./priceListsView.vue?vue&type=script&lang=js"
export * from "./priceListsView.vue?vue&type=script&lang=js"

import "./priceListsView.vue?vue&type=style&index=0&id=a2d9dcda&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2d9dcda"]])

export default __exports__